import Vue from 'vue';
import Vuex from 'vuex';

import * as CvsStore from '../containers/cvs/store';
import * as CvStore from '../containers/cv/store';
import * as CvDesign from '../containers/cv-design/store';
import * as CvSetting from '../containers/cv-setting/store';
import * as CvSectionProfileStore from '../containers/cv-section-profile/store';
import * as CoverLettersStore from '../containers/cover-letters/store';
import * as AdminCvCommentStore from '../containers/cv-comment/stores';
import * as AccountStore from '../containers/account/store';
import * as SettingsStore from './modules/settings';
import * as UiStore from './modules/ui';
import * as ErrorStore from './modules/error';
import APIPlugin from './plugins/api';
import * as PhotoStore from './modules/photos/store';
import * as CvPreview from '@/store/modules/cvPreview';
import * as CvSectionGalleryStoreEdit from '@/store/modules/cvSectionGalleryEdit';
import * as CvSectionGalleryStoreNew from '@/store/modules/cvSectionGalleryNew';
import * as CvSectionGalleryItemStoreEdit from '@/store/modules/cvSectionGalleryItemEdit';
import * as CvSectionGalleryItemStoreNew from '@/store/modules/cvSectionGalleryItemNew';
import * as CvSectionLinkStoreEdit from '@/store/modules/cvSectionLinkEdit';
import * as CvSectionLinkStoreNew from '@/store/modules/cvSectionLinkNew';
import * as CvSectionLinkItemStoreEdit from '@/store/modules/cvSectionLinkItemEdit';
import * as CvSectionLinkItemStoreNew from '@/store/modules/cvSectionLinkItemNew';
import * as CvSectionSkillStoreEdit from '@/store/modules/cvSectionSkillEdit';
import * as CvSectionSkillStoreNew from '@/store/modules/cvSectionSkillNew';
import * as CvSectionSkillItemStoreEdit from '@/store/modules/cvSectionSkillItemEdit';
import * as CvSectionSkillItemStoreNew from '@/store/modules/cvSectionSkillItemNew';
import * as CvSectionDateStoreNew from '@/store/modules/cvSectionDateNew';
import * as CvSectionDateStoreEdit from '@/store/modules/cvSectionDateEdit';
import * as CvSectionDateItemStoreEdit from '@/store/modules/cvSectionDateItemEdit';
import * as CvSectionDateItemStoreNew from '@/store/modules/cvSectionDateItemNew';
import * as CvSectionTextStoreNew from '@/store/modules/cvSectionTextNew';
import * as CvSectionTextStoreEdit from '@/store/modules/cvSectionTextEdit';

Vue.use(Vuex);

export interface RootState {
  [SettingsStore.namespace]: SettingsStore.State;
  [UiStore.namespace]: UiStore.State;
  [ErrorStore.namespace]: ErrorStore.State;
  [CvsStore.namespace]: CvsStore.State;
  [CvStore.namespace]: CvStore.State;
  [CvDesign.namespace]: CvDesign.State;
  [CvPreview.namespace]: CvPreview.State;
  [CvSetting.namespace]: CvSetting.State;
  [CvSectionProfileStore.namespace]: CvSectionProfileStore.State;
  [CvSectionTextStoreNew.namespace]: CvSectionTextStoreNew.State;
  [CvSectionTextStoreEdit.namespace]: CvSectionTextStoreEdit.State;
  [CvSectionDateStoreEdit.namespace]: CvSectionDateStoreEdit.State;
  [CvSectionDateStoreNew.namespace]: CvSectionDateStoreNew.State;
  [CvSectionDateItemStoreNew.namespace]: CvSectionDateItemStoreNew.State;
  [CvSectionDateItemStoreEdit.namespace]: CvSectionDateItemStoreEdit.State;
  [CvSectionSkillStoreNew.namespace]: CvSectionSkillStoreNew.State;
  [CvSectionSkillStoreEdit.namespace]: CvSectionSkillStoreEdit.State;
  [CvSectionSkillItemStoreNew.namespace]: CvSectionSkillItemStoreNew.State;
  [CvSectionSkillItemStoreEdit.namespace]: CvSectionSkillItemStoreEdit.State;
  [CvSectionLinkStoreNew.namespace]: CvSectionLinkStoreNew.State;
  [CvSectionLinkStoreEdit.namespace]: CvSectionLinkStoreEdit.State;
  [CvSectionLinkItemStoreEdit.namespace]: CvSectionLinkItemStoreEdit.State;
  [CvSectionLinkItemStoreNew.namespace]: CvSectionLinkItemStoreNew.State;
  [CvSectionGalleryStoreEdit.namespace]: CvSectionGalleryStoreEdit.State;
  [CvSectionGalleryStoreNew.namespace]: CvSectionGalleryStoreNew.State;
  [CvSectionGalleryItemStoreEdit.namespace]: CvSectionGalleryItemStoreEdit.State;
  [CvSectionGalleryItemStoreNew.namespace]: CvSectionGalleryItemStoreNew.State;
  [CoverLettersStore.namespace]: CoverLettersStore.State;
  [PhotoStore.namespace]: PhotoStore.State;
  [AdminCvCommentStore.namespace]: AdminCvCommentStore.State;
  [AccountStore.namespace]: AccountStore.State;
}

export default new Vuex.Store({
  plugins: [APIPlugin()],
  modules: {
    [SettingsStore.namespace]: SettingsStore.module,
    [UiStore.namespace]: UiStore.module,
    [ErrorStore.namespace]: ErrorStore.module,
    [CvsStore.namespace]: CvsStore.module,
    [CvStore.namespace]: CvStore.module,
    [CvDesign.namespace]: CvDesign.module,
    [CvPreview.namespace]: CvPreview.module,
    [CvSetting.namespace]: CvSetting.module,
    [CvSectionProfileStore.namespace]: CvSectionProfileStore.module,
    [CvSectionTextStoreNew.namespace]: CvSectionTextStoreNew.module,
    [CvSectionTextStoreEdit.namespace]: CvSectionTextStoreEdit.module,
    [CvSectionDateStoreEdit.namespace]: CvSectionDateStoreEdit.module,
    [CvSectionDateStoreNew.namespace]: CvSectionDateStoreNew.module,
    [CvSectionDateItemStoreNew.namespace]: CvSectionDateItemStoreNew.module,
    [CvSectionDateItemStoreEdit.namespace]: CvSectionDateItemStoreEdit.module,
    [CvSectionSkillStoreNew.namespace]: CvSectionSkillStoreNew.module,
    [CvSectionSkillStoreEdit.namespace]: CvSectionSkillStoreEdit.module,
    [CvSectionSkillItemStoreNew.namespace]: CvSectionSkillItemStoreNew.module,
    [CvSectionSkillItemStoreEdit.namespace]: CvSectionSkillItemStoreEdit.module,
    [CvSectionLinkStoreNew.namespace]: CvSectionLinkStoreNew.module,
    [CvSectionLinkStoreEdit.namespace]: CvSectionLinkStoreEdit.module,
    [CvSectionLinkItemStoreEdit.namespace]: CvSectionLinkItemStoreEdit.module,
    [CvSectionLinkItemStoreNew.namespace]: CvSectionLinkItemStoreNew.module,
    [CvSectionGalleryStoreEdit.namespace]: CvSectionGalleryStoreEdit.module,
    [CvSectionGalleryStoreNew.namespace]: CvSectionGalleryStoreNew.module,
    [CvSectionGalleryItemStoreEdit.namespace]:
      CvSectionGalleryItemStoreEdit.module,
    [CvSectionGalleryItemStoreNew.namespace]:
      CvSectionGalleryItemStoreNew.module,
    [CoverLettersStore.namespace]: CoverLettersStore.module,
    [PhotoStore.namespace]: PhotoStore.module,
    [AdminCvCommentStore.namespace]: AdminCvCommentStore.module,
    [AccountStore.namespace]: AccountStore.module,
  },
});
